import { render } from "./Barqdisplay.vue?vue&type=template&id=4649a984&scoped=true"
import script from "./Barqdisplay.vue?vue&type=script&lang=js"
export * from "./Barqdisplay.vue?vue&type=script&lang=js"

import "./Barqdisplay.vue?vue&type=style&index=0&id=4649a984&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4649a984"]])

export default __exports__